/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The AgentAvailableContactSlot model module.
 * @module model/AgentAvailableContactSlot
 * @version 1.0.0
 */
class AgentAvailableContactSlot {
    /**
     * Constructs a new <code>AgentAvailableContactSlot</code>.
     * @alias module:model/AgentAvailableContactSlot
     * @param wday {Number} 曜日（0=日曜〜6=土曜）
     * @param timeSlot {module:model/AgentAvailableContactSlot.TimeSlotEnum} 2時間枠
     */
    constructor(wday, timeSlot) { 
        
        AgentAvailableContactSlot.initialize(this, wday, timeSlot);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, wday, timeSlot) { 
        obj['wday'] = wday;
        obj['time_slot'] = timeSlot;
    }

    /**
     * Constructs a <code>AgentAvailableContactSlot</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AgentAvailableContactSlot} obj Optional instance to populate.
     * @return {module:model/AgentAvailableContactSlot} The populated <code>AgentAvailableContactSlot</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AgentAvailableContactSlot();

            if (data.hasOwnProperty('wday')) {
                obj['wday'] = ApiClient.convertToType(data['wday'], 'Number');
            }
            if (data.hasOwnProperty('time_slot')) {
                obj['time_slot'] = ApiClient.convertToType(data['time_slot'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>AgentAvailableContactSlot</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AgentAvailableContactSlot</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of AgentAvailableContactSlot.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['time_slot'] && !(typeof data['time_slot'] === 'string' || data['time_slot'] instanceof String)) {
            throw new Error("Expected the field `time_slot` to be a primitive type in the JSON string but got " + data['time_slot']);
        }

        return true;
    }


}

AgentAvailableContactSlot.RequiredProperties = ["wday", "time_slot"];

/**
 * 曜日（0=日曜〜6=土曜）
 * @member {Number} wday
 */
AgentAvailableContactSlot.prototype['wday'] = undefined;

/**
 * 2時間枠
 * @member {module:model/AgentAvailableContactSlot.TimeSlotEnum} time_slot
 */
AgentAvailableContactSlot.prototype['time_slot'] = undefined;





/**
 * Allowed values for the <code>time_slot</code> property.
 * @enum {String}
 * @readonly
 */
AgentAvailableContactSlot['TimeSlotEnum'] = {

    /**
     * value: "slot_9_11"
     * @const
     */
    "9_11": "slot_9_11",

    /**
     * value: "slot_11_13"
     * @const
     */
    "11_13": "slot_11_13",

    /**
     * value: "slot_13_15"
     * @const
     */
    "13_15": "slot_13_15",

    /**
     * value: "slot_15_17"
     * @const
     */
    "15_17": "slot_15_17",

    /**
     * value: "slot_17_19"
     * @const
     */
    "17_19": "slot_17_19",

    /**
     * value: "slot_19_21"
     * @const
     */
    "19_21": "slot_19_21"
};



export default AgentAvailableContactSlot;

